import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';

export const Divider: FC<PropsWithChildren> = ({ children }) => (
  <div className="c-fs-caption relative my-2 flex h-5 items-center justify-center overflow-hidden" role="separator">
    <div
      className={clsx(
        'relative',
        'before:absolute before:top-1/2 before:right-full before:w-screen before:-translate-x-2 before:border-t before:border-inherit before:opacity-25',
        'after:absolute after:top-1/2 after:left-full after:w-screen after:translate-x-2 after:border-t after:border-inherit after:opacity-25',
      )}
    >
      {children}
    </div>
  </div>
);
